import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  // title = 'jrb-app';
  // phone = '07778 808950';
  phones = [ '07778 808950', '01892 891874', '01797 225950'];
}
